import React, { useMemo } from 'react';
import {
	Wrapper,
	Container,
	TableContainer,
	AnalysisDescription,
} from './DetailedAnalysis.styles';
import { AgGridReact } from '@ag-grid-community/react';
import { defaultGridHeight } from './utils';
import { useOutofPolicySpendContext } from 'contexts/CategoryInsightsKpi/OutofPolicySpendProvider';

const OutofPolicySpendExplore = () => {
	const { gridData } = useOutofPolicySpendContext();
	const gridStyle = useMemo(() => defaultGridHeight, []);

	return (
		<Wrapper>
			<Container>
				<AnalysisDescription>
					{`List of suppliers that are not approved by the entity.`}
				</AnalysisDescription>
				<TableContainer>
					<div style={gridStyle} className="ag-theme-balham">
						<AgGridReact {...gridData} />
					</div>
				</TableContainer>
			</Container>
		</Wrapper>
	);
};

export default OutofPolicySpendExplore;
